import { render, staticRenderFns } from "./SyntaxErrors.vue?vue&type=template&id=5a63fd42&scoped=true&"
import script from "./SyntaxErrors.vue?vue&type=script&lang=js&"
export * from "./SyntaxErrors.vue?vue&type=script&lang=js&"
import style0 from "./SyntaxErrors.vue?vue&type=style&index=0&id=5a63fd42&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a63fd42",
  null
  
)

/* custom blocks */
import block0 from "./SyntaxErrors.vue?vue&type=custom&index=0&blockType=messages"
if (typeof block0 === 'function') block0(component)

export default component.exports